<template>
  <span>
    <Upload
      action="/api/upload/upload"
      :on-success = "upload"
      :on-remove="uploadRemove"
    >
      <slot name="main">
        <Button icon="ios-cloud-upload-outline" size="small" :disabled="count>0">选择文件（上传图片）</Button>
      </slot>
    </Upload>
  </span>
</template>

<script>
  export default {
    props:{
      value:{
        type:Number,//附件ID
        default:0
      }
    },
    data(){
      return{
        count:0,
      }
    },
    methods:{
      upload(response, file, fileList){
        this.value = response.upload.id;
        this.$emit('input',this.value);
        this.count++;
      },
      uploadRemove(file, fileList){
        this.value = 0;
        this.$emit('input',this.value);
        this.count--;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/upload/UploadOne.vue